/* Así funciona · Ventilador de Techo con Luz LED y Control (1881590)
   Piezas reales (tiendas/nayhogar/funciona/ventilador-de-techo-con-luz-led-y-control/hacer.py): la foto del ventilador
   instalado en la sala, sus 6 aspas recortadas que giran sobre la elipse real de sus puntas (vistas desde abajo) con
   desenfoque de movimiento según la velocidad, la pantalla de la lámpara que se prende en los 3 tonos reales y el
   CONTROL REMOTO REAL con sus botones: apagar, luz, luz de noche, cálida/natural/blanca, ventilador, 3 velocidades y
   temporizador 1h/2h/4h. Ficha: rosca E27, 6 aspas, 3 velocidades, 3 tonos de luz, temporizador, control, 80 W. */
NHF.escena('ventilador-de-techo-con-luz-led-y-control', function (E) {
  const D = /*DATOS*/{"quieta":"fn-ventilador-de-techo-con-luz-led-y-control-quieta.webp","sala":"fn-ventilador-de-techo-con-luz-led-y-control-sala.webp","aspas":{"src":"fn-ventilador-de-techo-con-luz-led-y-control-aspas.webp","caja":[291,173,1008,536]},"lampara":{"src":"fn-ventilador-de-techo-con-luz-led-y-control-lampara.webp","caja":[663,424,291,202],"centro":[807,520],"r":[143,106]},"giro":{"centro":[802.8,429.7],"aplaste":0.5998,"inclinacion":0.0322,"a":502.4},"control":{"src":"fn-ventilador-de-techo-con-luz-led-y-control-control.webp","w":360,"h":633,"botones":{"apagar":[138.5,80.3],"luz":[215.7,90.9],"luna":[290.8,98.3],"calida":[127.9,147.0],"natural":[205.1,159.1],"blanca":[280.8,169.3],"ventilador":[173.6,371.7],"v1":[84.2,431.3],"v2":[161.5,443.8],"v3":[240.2,452.4],"t1":[71.8,507.0],"t2":[150.5,517.9],"t4":[229.7,529.6]},"r":31.2}}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [190, 40, 1220, 740], vistaMovil: [290, 40, 1030, 790] });
  E.titulo('Préndelo con [su control].', 'Toca los botones del control real: aspas, velocidades, luz en 3 tonos y apagado programado.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas ---------- */
  S.img(D.sala, null, { z: 1, alt: 'Ventilador de techo con luz instalado en una sala' });
  const lz = S.canvas([240, 130, 1110, 620], { z: 2, res: Math.min(1, (window.devicePixelRatio || 1) * 0.55) });
  const quieta = S.img(D.quieta, null, { z: 3 });
  quieta.style.transition = 'opacity .35s linear';
  const noche = S.div([0, 0, 1600, 1600], { z: 4, opacidad: 0 });
  noche.style.background = '#121621'; noche.style.mixBlendMode = 'multiply'; noche.style.transition = 'opacity .9s ease';
  const L = D.lampara;
  const derrame = S.luz(L.centro[0], L.centro[1] + 30, 640, { z: 5, color: '#FFC27A', nucleo: .06, centro: 'rgba(255,240,215,.95)' });
  derrame.el.style.transition = 'opacity .5s ease';
  const lamp = S.img(L.src, L.caja, { z: 6 });
  lamp.style.transition = 'filter .45s ease';
  const brillo = S.luz(L.centro[0], L.centro[1] + 10, 190, { z: 7, color: '#FFD9A6', ry: 150, nucleo: .3 });
  brillo.el.style.transition = 'opacity .45s ease';
  let aspas = null;
  E.cargar([D.sala, D.quieta, D.lampara.src, D.aspas.src, D.control.src]).then(imgs => { aspas = imgs[3]; S.cargando(false); });

  /* ---------- estado ---------- */
  const ST = { vel: 0, ultVel: 1, luz: false, tono: 'calida', noche: false, timer: null, hecho: { vent: false, vel: false, luz: false, timer: false } };
  const TONOS = {
    calida: { n: 'Cálida', color: '#FFC27A', filtro: 'saturate(1.05)' },
    natural: { n: 'Natural', color: '#FFE6C7', filtro: 'saturate(.5) brightness(1.03)' },
    blanca: { n: 'Blanca', color: '#EEF4FF', filtro: 'saturate(.08) brightness(1.06) hue-rotate(-8deg)' },
    luna: { n: 'Luz de noche', color: '#FFB25E', filtro: 'saturate(1.1) brightness(.7)' }
  };
  const RAD = [0, 13.5, 19.5, 25.5]; // velocidad angular de cada nivel (rad/s)

  /* ---------- panel: día/noche, control real y lecturas ---------- */
  const top = E.el('div', 'vt-top'); E.panel.prepend(top); top.style.marginBottom = '16px';
  E.seg([{ id: 'dia', texto: 'De día' }, { id: 'noche', texto: 'De noche' }], v => { ST.noche = v === 'noche'; pintarLuz(); }, { etiqueta: 'Hora del día', en: top });
  E.pasos(['Prende el ventilador', 'Cambia la velocidad', 'Prende la luz y escoge el tono', 'Programa que se apague solo']);
  E.paso(0);
  const fila = E.el('div', 'vt-fila'); E.ctrls.appendChild(fila);
  fila.style.cssText = 'display:flex;gap:22px;align-items:center;width:100%';
  const C = D.control;
  const mando = E.control({
    src: C.src, w: C.w, h: C.h, botones: C.botones, r: C.r, en: fila, ancho: window.innerWidth < 760 ? '56%' : '205px', alt: 'Control remoto del ventilador',
    etiquetas: { apagar: 'Apagar todo', luz: 'Luz', luna: 'Luz de noche', calida: 'Luz cálida', natural: 'Luz natural', blanca: 'Luz blanca', ventilador: 'Ventilador',
      v1: 'Velocidad 1', v2: 'Velocidad 2', v3: 'Velocidad 3', t1: 'Apagar en 1 hora', t2: 'Apagar en 2 horas', t4: 'Apagar en 4 horas' },
    alTocar: tocar
  });
  const info = E.el('div', 'vt-info'); fila.appendChild(info);
  info.style.cssText = 'display:grid;gap:18px;min-width:0;flex:1';
  const lVent = E.lectura({ etiqueta: 'Aspas', en: info }); lVent.poner('Quietas');
  const lLuz = E.lectura({ etiqueta: 'Luz', en: info }); lLuz.poner('Apagada');
  const lTimer = E.lectura({ etiqueta: 'Temporizador', en: info }); lTimer.poner('—');
  info.querySelectorAll('.nhf-lectura__v').forEach(v => { v.style.fontSize = 'clamp(26px,3vw,38px)'; });
  E.nota('Se enrosca como un bombillo (rosca E27). 80 W.');
  mando.pista(['ventilador']);
  S.pista('Toca el botón del ventilador en el control', 'toca');

  function tocar(id) {
    E.sonido.bip(1900);
    if (id === 'apagar') { ST.vel = 0; ST.luz = false; pararTimer(); }
    else if (id === 'ventilador') { ST.vel = ST.vel ? 0 : ST.ultVel; if (ST.vel) ST.hecho.vent = true; }
    else if (id === 'v1' || id === 'v2' || id === 'v3') { ST.vel = +id[1]; ST.ultVel = ST.vel; ST.hecho.vent = true; }
    else if (id === 'luz') { ST.luz = !ST.luz; if (ST.tono === 'luna' && ST.luz) ST.tono = 'calida'; if (ST.luz) ST.hecho.luz = true; }
    else if (id === 'luna') { ST.luz = true; ST.tono = 'luna'; ST.hecho.luz = true; }
    else if (id === 'calida' || id === 'natural' || id === 'blanca') { ST.luz = true; ST.tono = id; ST.hecho.luz = true; }
    else if (id[0] === 't') { if (ST.vel || ST.luz) { iniciarTimer(+id.slice(1)); ST.hecho.timer = true; } else { lTimer.poner('Prende algo', 'primero'); } }
    pintarLuz(); pintarVent(); guia();
  }
  function guia() {
    const h = ST.hecho;
    let paso = 0, pista = ['ventilador'], texto = 'Toca el botón del ventilador en el control';
    if (h.vent) { paso = 1; pista = ['v1', 'v2', 'v3']; texto = 'Prueba las 3 velocidades'; }
    if (h.vent && ST.velVistas >= 2) { paso = 2; pista = ['calida', 'natural', 'blanca']; texto = 'Prende la luz: cálida, natural o blanca'; }
    if (paso === 2 && h.luz && ST.tonosVistos >= 2) { paso = 3; pista = ['t1', 't2', 't4']; texto = 'Programa el apagado: 1, 2 o 4 horas'; }
    if (h.timer) { paso = 4; pista = []; texto = ''; }
    E.paso(paso); mando.pista(pista); S.pista(texto || null, 'toca');
    if (paso === 4) E.listo('Luz y aire con un solo aparato, todo desde el control.', reiniciar);
  }
  ST.velVistas = 0; ST.tonosVistos = 0;
  const vistas = new Set(), tonos = new Set();
  function pintarVent() {
    if (ST.vel) { vistas.add(ST.vel); ST.velVistas = vistas.size; }
    lVent.poner(ST.vel ? 'Velocidad ' + ST.vel : 'Quietas', ST.vel ? 'de 3' : '');
    if (ruido) ruido.volumen(ST.vel ? 0.012 + ST.vel * 0.009 : 0);
    else if (ST.vel && E.sonido.activo) ruido = E.sonido.ruido(0, 0.012 + ST.vel * 0.009, 700);
  }
  let ruido = null;
  function pintarLuz() {
    E.noche(ST.noche);
    noche.style.opacity = ST.noche ? (ST.luz ? 0.66 : 0.8) : 0;
    const t = TONOS[ST.tono];
    if (ST.luz) { tonos.add(ST.tono); ST.tonosVistos = tonos.size; }
    lamp.style.filter = ST.luz ? t.filtro : (ST.noche ? 'saturate(.1) brightness(.34)' : 'saturate(.12) brightness(.9) contrast(1.04)');
    const kLuna = ST.tono === 'luna' ? 0.45 : 1;
    brillo.set(ST.luz ? (ST.noche ? 0.9 : 0.55) * kLuna : 0, t.color);
    derrame.set(ST.luz ? (ST.noche ? 0.85 : 0.32) * kLuna : 0, t.color);
    lLuz.poner(ST.luz ? t.n : 'Apagada');
  }

  /* ---------- temporizador (en la demostración el tiempo pasa rápido) ---------- */
  function pararTimer() { if (ST.timer) { clearInterval(ST.timer.id); ST.timer = null; } lTimer.poner('—'); E.nota('Se enrosca como un bombillo (rosca E27). 80 W.'); }
  function iniciarTimer(horas) {
    pararTimer();
    const total = horas * 3600, dur = 7000, t0 = performance.now();
    E.nota('Demostración: el tiempo pasa rápido. En tu casa se apaga sola a las ' + horas + (horas === 1 ? ' hora.' : ' horas.'));
    ST.timer = { id: setInterval(() => {
      const k = Math.min(1, (performance.now() - t0) / dur), q = Math.round(total * (1 - k));
      const hh = Math.floor(q / 3600), mm = Math.floor(q % 3600 / 60);
      lTimer.poner(hh + ':' + String(mm).padStart(2, '0'), 'para apagarse');
      if (k >= 1) { clearInterval(ST.timer.id); ST.timer = null; ST.vel = 0; ST.luz = false; pintarLuz(); pintarVent(); lTimer.poner('Se apagó', 'sola'); E.sonido.bip(1500); }
    }, 60) };
  }

  /* ---------- giro de las aspas reales ---------- */
  let ang = 0, w = 0;
  const G = D.giro, A = D.aspas;
  const VUELTA = Math.PI * 2;
  E.bucle((t, dt) => {
    const meta = RAD[ST.vel] || 0;
    if (meta === 0 && w < 3 && w > 0) {
      // se detiene en una vuelta completa: al quedar quieto, las aspas son otra vez la foto real exacta
      const resto = ang - Math.floor(ang / VUELTA) * VUELTA;
      w = Math.min(w, Math.sqrt(2 * 1.15 * resto));
      if (resto < 0.004 || w < 0.01) { ang = Math.round(ang / VUELTA) * VUELTA; w = 0; }
    } else {
      // inercia real: arranca en ~1,5 s y se frena despacio
      const acel = meta > w ? 9 : 4.2;
      w += Math.sign(meta - w) * Math.min(Math.abs(meta - w), acel * dt);
    }
    ang -= w * dt; // visto desde abajo gira contra las manecillas del reloj
    const moviendo = w > 0;
    quieta.style.opacity = moviendo ? 0 : 1;
    if (!aspas) return;
    lz.limpiar();
    if (!moviendo) return;
    const barrido = Math.min(Math.PI / 3, w * (1 / 30) * 1.15);
    const n = Math.max(1, Math.min(16, Math.round(barrido / 0.035)));
    E.fx.giro(lz, { img: aspas, caja: A.caja, centro: G.centro, inclinacion: G.inclinacion, aplaste: G.aplaste, angulo: ang, barrido: -barrido, muestras: n });
  });

  function reiniciar() {
    E.noListo(); pararTimer();
    Object.assign(ST, { vel: 0, ultVel: 1, luz: false, tono: 'calida', hecho: { vent: false, vel: false, luz: false, timer: false }, velVistas: 0, tonosVistos: 0 });
    vistas.clear(); tonos.clear(); pintarLuz(); pintarVent(); guia();
  }
  pintarLuz();
});
